import { PaymentApi } from "./apiServices/PaymentApi";
import { SpinnerService } from "../services/spinner.service";
import { NetworkErrorService } from "../services/NetworkError.service";
import { UserStore } from "../services/stores/UserStore";
import { PaymentHistory } from "../models/PaymentHistory";
import { PaymentRequest } from "../models/PaymentRequest";
import { PropertyApi } from "../services/apiServices/PropertyApi";
import { Property } from "../models/Property";
import { take } from "rxjs/operators";
import { Inject, Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { DialogPreCancelComponent } from "@app/components/sharedDialogs/dialogPreCancel.component";
import { OneButtonDialogComponent } from "@app/components/sharedDialogs/oneButtonDialog.component";
import { Router } from "@angular/router";

@Injectable({ providedIn: "root" })
export class PaymentHistoryCancelService {

    property: Property

    constructor(
        @Inject(MatDialog) private dialog: MatDialog,
        @Inject(PaymentApi) private paymentApi: PaymentApi,
        @Inject(PropertyApi) private propertyApi: PropertyApi,
        @Inject(SpinnerService) private spinnerService: SpinnerService,
        @Inject(NetworkErrorService) private networkErrorService: NetworkErrorService,
        @Inject(UserStore) private UserStore: UserStore,
        @Inject(Router) private router: Router) {

        this.spinnerService.closeSpinner();
    }

    confirmCancelPayment(payment: PaymentHistory, property: Property) {
        this.spinnerService.showSpinner();
        this.property = property;

        const dialogRef = this.dialog.open(DialogPreCancelComponent, {
            data: { paymentAmount: payment.amount }
        })

        dialogRef.afterClosed().pipe(take(1)).subscribe((data) => {
            if (data === 'cancel') {
                this.cancel(payment)
            } else {
                this.spinnerService.closeSpinner();
            }
        });
    };

    cancel(payment: PaymentHistory) {
        this.paymentApi.deletePayment(false, payment.id).pipe(take(1)).subscribe({
            next: () => {
                this.spinnerService.closeSpinner();

                this.router.navigateByUrl('/properties/paymentCancel', {
                    state: {
                        'email': this.UserStore.getEmail(),
                        'paymentRequest': this.createPartialPaymentRequest(payment),
                        'paymentConfirmationNumber': payment.vendorItemNumber,
                        'paymentId': payment.id
                    }
                });
            },
            error: () => {
                const dialogRef = this.dialog.open(OneButtonDialogComponent, {
                    closeOnNavigation: false,
                    disableClose: true,
                    data: {
                        header: "The window to cancel this payment has closed.",
                        message: "The status for this payment will be updated shortly.",
                        buttonText: 'Okay'
                    }
                })

                dialogRef.afterClosed().pipe(take(1)).subscribe(() => {
                    this.spinnerService.closeSpinner();
                });
            }
        })
    }

    createPartialPaymentRequest(payment: PaymentHistory): PaymentRequest {
        const paymentAmount = {
            feeAmount: null,
            totalPaymentAmount: Number(payment.amount.toFixed(2)),
            principalAmount: null,
        };

        return {
            payment: paymentAmount,
            paymentMethod: payment.paymentMethod,
            property: this.property,
            acceptedTerms: true, // Required?
            acceptedTermsDate: null // Required?
        };
    }
}
